import MainLink from "./MainLink";
import { useAppDispatch } from "App/store";
import { createStyles, Navbar, UnstyledButton } from "@mantine/core";
import { Logout } from "tabler-icons-react";
import { logout } from "features/backstage/auth/authSlice";
import { useNavigate } from "react-router-dom";
import api, { useFunctionsQuery } from "services/api";
import { FUNCTIONS_URL } from "App/routes";

const useStyles = createStyles((theme, _params, getRef) => {
  const icon = getRef("icon");
  return {
    header: {
      paddingBottom: theme.spacing.md,
      marginBottom: theme.spacing.md * 1.5,
      borderBottom: `1px solid ${
        theme.colorScheme === "dark"
          ? theme.colors.dark[4]
          : theme.colors.gray[2]
      }`,
    },

    footer: {
      paddingTop: theme.spacing.md,
      marginTop: theme.spacing.md,
      borderTop: `1px solid ${
        theme.colorScheme === "dark"
          ? theme.colors.dark[4]
          : theme.colors.gray[2]
      }`,
    },

    link: {
      ...theme.fn.focusStyles(),
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      fontSize: theme.fontSizes.sm,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.dark[1]
          : theme.colors.gray[7],
      padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
      borderRadius: theme.radius.sm,
      fontWeight: 500,
      width: "100%",

      "&:hover": {
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.dark[6]
            : theme.colors.gray[0],
        color: theme.colorScheme === "dark" ? theme.white : theme.black,

        [`& .${icon}`]: {
          color: theme.colorScheme === "dark" ? theme.white : theme.black,
        },
      },
    },

    linkIcon: {
      ref: icon,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.dark[2]
          : theme.colors.gray[6],
      marginRight: theme.spacing.sm,
    },

    linkActive: {
      "&, &:hover": {
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.fn.rgba(theme.colors[theme.primaryColor][8], 0.25)
            : theme.colors[theme.primaryColor][0],
        color:
          theme.colorScheme === "dark"
            ? theme.white
            : theme.colors[theme.primaryColor][7],
        [`& .${icon}`]: {
          color:
            theme.colors[theme.primaryColor][
              theme.colorScheme === "dark" ? 5 : 7
            ],
        },
      },
    },
  };
});

const NavMenu = () => {
  const { classes } = useStyles();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: currUserFunctions = [] } = useFunctionsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <header>
      <Navbar width={{ base: 300, sm: 200, lg: 300 }} p="md">
        <Navbar.Section grow>
          {currUserFunctions.map((x) => (
            <MainLink
              key={x.funNo}
              label={x.funName}
              to={`${FUNCTIONS_URL}/${x.url}`}
            />
          ))}
          <a
            href="https://docs.google.com/document/d/1mQruSjgvBNB_U6G8jkCpejEPciCIlTa-yRGpGLXwlAU/edit?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div
              style={{ fontSize: "14px", lineHeight: "1.55", padding: "10px" }}
            >
              儀表板介接資料說明文件
            </div>
          </a>
        </Navbar.Section>
        <Navbar.Section className={classes.footer}>
          <UnstyledButton
            className={classes.link}
            onClick={() => {
              dispatch(logout());
              dispatch(api.util.resetApiState());
              navigate("/", { replace: true });
            }}
          >
            <Logout className={classes.linkIcon} />
            <span>登出</span>
          </UnstyledButton>
        </Navbar.Section>
      </Navbar>
    </header>
  );
};

export default NavMenu;
